module.exports = __webpack_public_path__ + "media/images/icons/wizard/progress/bottom-41609d049e4460021e8dd1b7ece5bde7.svg";